import { useApiClientAuthentication } from './useApiClientAuthentication';
import { useInvitationClaims } from './useInvitationClaims';

export function useAuthenticatedSessionOrchestration() {
  useApiClientAuthentication();
  useInvitationClaims();
}

